import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const search = window.location.search;
const params = new URLSearchParams(search);
const param = params.get('p');

export function RedirectConclusion() {
  const history = useHistory();

  useEffect(() => {
    history.push({
      pathname: '/app/conclusao',
    });
    sessionStorage.setItem('conclusionParam', param);
  }, []);
  return <></>;
}
